export default {
      id: "i-arrow-up-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-up",
      toString: function () {
        return this.url;
      }
    }